import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Card } from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/store";
import { setActiveWorkflow } from "src/store/workflowSlice";
import { InspectionWorkflow } from "./types/inspectionWorkflow";

const WorkflowCard = ({
  workflow,
}: { workflow: InspectionWorkflow }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handleClick = async () => {
    await dispatch(setActiveWorkflow(workflow));
    navigate(`/configurationDrivenInspections/workflows/${workflow.template_id}/checkpoints`);
  };

  return (
    <Card spacingInset="400" onClick={handleClick}>
      <Column spacing="200">
        <Row alignmentHorizontal="justify" height={64}>
          <Column spacing="200">
            <Row>
              <Text type="b300">{workflow.name}</Text>
            </Row>
          </Column>
          <Icon tokens={chevronRightSmallTokens} />
        </Row>
      </Column>
    </Card>
  );
};

export default WorkflowCard;
